import '@splidejs/splide/dist/css/splide-core.min.css'
import Splide from '@splidejs/splide'

const relatedCarousel = document.querySelectorAll('[data-related-carousel]')

document.addEventListener('DOMContentLoaded', function () {
  relatedCarousel.forEach(carousel => {
    const splideEl = carousel.querySelector('.splide')
    new Splide(splideEl, {
      perMove: 1,
      perPage: 4,
      gap: 30,
      speed: 1000,
      pagination: false,
      arrows: false,
      drag: false,
      breakpoints: {
        1200: {
          perPage: 2,
          drag: true
        },
        640: {
          perPage: 1,
          gap: 15,
          drag: true,
          arrows: false,
          padding: {
            right: "30px"
          }
        }
      }
    }).mount();
  })
});